import apiInstance from "./api";

export type FeaturedType = "rider" | "brandTeam";
export interface FeaturedContextParams {
	sportId: string;
	seriesId: string;
}

export interface UpdateFeaturedPayload {
	description: string;
	sportId: string;
	seriesId: string;
	riderId?: string;
	brandTeamId?: string;
}

export const getFeaturedConfigs = async (params?: Partial<FeaturedContextParams>) => {
	return apiInstance.get("/featured", { params });
};

export const getFeaturedByType = async (
	type: FeaturedType,
	params: FeaturedContextParams,
) => {
	return apiInstance.get(`/featured/${type}`, { params });
};

export const updateFeaturedByType = async (
	type: FeaturedType,
	payload: UpdateFeaturedPayload,
) => {
	return apiInstance.put(`/featured/${type}`, payload);
};
